import axios from 'axios'

const baseURL = process.env.VUE_APP_PRODUCT_SERVICE

export default {
  namespaced: true,
  state: {
    specials: null,
    special: null
  },
  mutations: {
    setSpecials (state, payload) {
      state.specials = payload
    },
    setSpecial (state, payload) {
      state.special = payload
    }
  },
  actions: {
    async getSpecials ({ commit }) {
      const promise = axios.get(baseURL + '/api/specials')

      promise.then(response => {
        commit('setSpecials', response.data.data)
      })

      return promise
    },
    async getSpecial ({ commit }, id) {
      const promise = axios.get(baseURL + '/api/specials/' + id)

      promise.then(response => {
        commit('setSpecial', response.data.data)
      })

      return promise
    }
  }
}
